import { FileText } from 'lucide-react';
import OrderCard from './OrderCard';

export default function OrderList({
  orders,
  loading,
  hasActiveFilters,
  copiedCode,
  onCopy,
  onExpire,
  onCreate,
  onClearFilters,
}) {
  if (loading) {
    return <div className="text-center py-12 text-gray-500" data-testid="orders-loading">Cargando...</div>;
  }

  if (orders.length === 0) {
    return (
      <div className="bg-white rounded-xl p-12 text-center border border-gray-200" data-testid="orders-empty">
        <FileText className="w-16 h-16 mx-auto mb-4 text-gray-300" />
        <h3 className="text-lg font-semibold text-gray-700 mb-2">
          {hasActiveFilters ? 'No se encontraron órdenes' : 'No hay órdenes'}
        </h3>
        <p className="text-gray-600 mb-6">
          {hasActiveFilters
            ? 'Intenta ajustar los filtros para ver más resultados'
            : 'Crea tu primera orden de pago'}
        </p>
        {hasActiveFilters ? (
          <button
            onClick={onClearFilters}
            className="px-6 py-3 text-white rounded-lg"
            style={{ backgroundColor: '#003594' }}
          >
            Limpiar Filtros
          </button>
        ) : (
          <button
            onClick={onCreate}
            className="px-6 py-3 text-white rounded-lg"
            style={{ backgroundColor: '#003594' }}
          >
            Crear Primera Orden
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between mb-4">
        <p className="text-sm text-gray-600">
          Mostrando {orders.length} orden{orders.length !== 1 ? 'es' : ''}
          {hasActiveFilters && ' (filtradas)'}
        </p>
      </div>
      {orders.map((order) => (
        <OrderCard
          key={order.order_id}
          order={order}
          copiedCode={copiedCode}
          onCopy={onCopy}
          onExpire={onExpire}
        />
      ))}
    </div>
  );
}
